import { Link } from 'react-router-dom'
import { Box, Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { ExitToApp, ManageAccounts } from '@mui/icons-material';
import { useAuth } from 'lib/auth';
import { useAppContext } from 'AppContextProvider';

interface UserMenuProps {
  onClose: () => void
}

export default function UserMenu({ onClose }: UserMenuProps) {
  const { user } = useAuth();
  const { state } = useAppContext();
  
  return (
    <>
      { user && <Box p={3}>
        <Typography variant="body1">{user.profile.firstname} {user.profile.lastname}</Typography>
        <Typography variant="body2">{user.profile.email}</Typography>
      </Box> }

      <Divider />

      { state.accounts.length > 1 && 
        <>
          <Box sx={{maxHeight: 300, overflow: 'auto'}}>
              <ListItem button onClick={() => onClose()} component={Link} to={`/accounts`}>
                <ListItemIcon><ManageAccounts /></ListItemIcon>
                <ListItemText>Switch account</ListItemText>
              </ListItem>
          </Box>
          <Divider />
        </>  
      }

      <List>
        <ListItem button onClick={() => onClose()} component={Link} to="/logout">
          <ListItemIcon><ExitToApp /></ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </ListItem>
      </List>
    </>
  )
}